import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { KnowledgeHubComponent } from './knowledge-hub/knowledge-hub.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { GetAnswerComponent } from './get-answer/get-answer.component';
import { KhDocComponent } from './kh-doc/kh-doc.component';
import { SavedAnswerComponent } from './saved-answer/saved-answer.component';
import { TrendingQuesionsComponent } from './trending-quesions/trending-quesions.component';
import { HistoryComponent } from './history/history.component';
import { RedashDashboardComponent } from './redash-dashboard/redash-dashboard.component';
import { AuthGuard } from './auth.guard'
import { TaskWorkComponent } from './task-work/task-work.component';
import { QuestionAnswerComponent } from './question-answer/question-answer.component';
import { FaqDetailComponent } from './faq-detail/faq-detail.component';
import { KhDocPageComponent } from './kh-doc-page/kh-doc-page.component';
import { DatainsightComponent } from './datainsight/datainsght.component';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: '',
    component: DashboardComponent,
   
    children: [
      {path: 'dashboard', component:RedashDashboardComponent, canActivate: [AuthGuard]},
      { path: 'knowledgehub', component: KnowledgeHubComponent, canActivate: [AuthGuard] },
      { path: 'get-answer' , component: GetAnswerComponent, canActivate: [AuthGuard]},
      { path: 'saved-answer' , component: SavedAnswerComponent, canActivate: [AuthGuard]},
      { path: 'history' , component: HistoryComponent, canActivate: [AuthGuard]},
      { path: 'collection/:documentname', component: KhDocComponent, canActivate: [AuthGuard]},
      {path: 'collection/:documentname/document/:doc',component:KhDocPageComponent,canActivate:[AuthGuard]},
      { path: 'trending-question' , component: TrendingQuesionsComponent, canActivate: [AuthGuard]},
      { path: 'task-work' , component: TaskWorkComponent,canActivate: [AuthGuard]},
      { path: 'question-answer' , component: QuestionAnswerComponent,canActivate: [AuthGuard]},
      // { path: 'document-page' , component: KhDocPageComponent,canActivate: [AuthGuard]},
      { path: 'data-insight' , component: DatainsightComponent,canActivate: [AuthGuard]},
      { path: 'faq', component: FaqDetailComponent },
       ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
